import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLockOpen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.75 14.4C12.75 13.9858 12.4142 13.65 12 13.65C11.5858 13.65 11.25 13.9858 11.25 14.4V17.4C11.25 17.8142 11.5858 18.15 12 18.15C12.4142 18.15 12.75 17.8142 12.75 17.4V14.4Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3.75C9.66037 3.75 7.75 5.66443 7.75 8.02439V10.25H17C19.0711 10.25 20.75 11.9289 20.75 14V18C20.75 20.0711 19.0711 21.75 17 21.75H7C4.92893 21.75 3.25 20.0711 3.25 18V14C3.25 12.1858 4.53832 10.6725 6.25 10.325V8.02439C6.25 4.84289 8.82506 2.25 12 2.25C14.7738 2.25 17.0881 4.22872 17.63 6.84805C17.7139 7.25367 17.4532 7.65052 17.0475 7.73445C16.6419 7.81837 16.2451 7.55758 16.1611 7.15195C15.7592 5.20913 14.0423 3.75 12 3.75ZM4.75 14C4.75 12.7574 5.75736 11.75 7 11.75H17C18.2426 11.75 19.25 12.7574 19.25 14V18C19.25 19.2426 18.2426 20.25 17 20.25H7C5.75736 20.25 4.75 19.2426 4.75 18V14Z",
		fill: "currentColor"
	})]
});
export { SvgIconLockOpen as ReactComponent };
